export default function Scroll() {

    // шапка
    checkHeaderPadding();
    archorsScroll();
    window.addEventListener('resize', function () {
        checkHeaderPadding();
        archorsScroll();
    })

    function checkHeaderPadding() {
        let html = document.querySelector('html'),
            header = document.querySelector('.header');

        html.style.scrollPaddingTop = (header.offsetHeight + 10) + 'px';

        document.querySelectorAll(".sidebar").forEach(item => {
            item.style.top = header.offsetHeight + 'px';
            item.style.maxHeight = document.documentElement.clientHeight - (header.offsetHeight ) + 'px';
        })

    }

    function archorsScroll() {

        let header = document.querySelector('.header');

        var topMenu = $("#anchors"),
            topMenuHeight = topMenu.outerHeight() + 15,
            // All list items
            menuItems = topMenu.find("a"),
            // Anchors corresponding to menu items
            scrollItems = menuItems.map(function () {
                var item = $($(this).attr("href"));
                if (item.length) {
                    return item;
                }
            });

// Bind to scroll
        $(window).scroll(function () {
            // Get container scroll position
            var fromTop = $(this).scrollTop() + header.offsetHeight + 10;

            // Get id of current scroll item
            var cur = scrollItems.map(function () {
                if ($(this).offset().top < fromTop)
                    return this;
            });
            // Get the id of the current element
            cur = cur[cur.length - 1];
            var id = cur && cur.length ? cur[0].id : "";
            // Set/remove active class
            menuItems
                .parent().removeClass("active")
                .end().filter("[href='#" + id + "']").parent().addClass("active");

            // .scrollIntoView()
        });

    }
}
